<template>
  <div>
    <form v-if="isLoadedNormal" @submit.prevent="save">
      <div class="form-group">
        <label for="device-token" class="prop-lable mb-1">Device token</label>
        <textarea
          id="device-token"
          v-model="deviceToken"
          class="form-control device-token mb-3"
          rows="4"
          required
        />
      </div>

      <b-button :to="{name: 'player_device_token_info'}">Cancel</b-button>
      <b-button type="submit" variant="primary">Save</b-button>
    </form>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
/**
 * @typedef { import('../model/push.js').DeviceTokenInfo } DeviceTokenInfo
 */

import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerDeviceTokenEdit',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {?string} */
      deviceToken: null,

      isSaving: false,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },
  },

  created() {
    this.loadDeviceTokenInfo();
  },

  methods: {
    loadDeviceTokenInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/device_token_info`;
      HTTP.get(url)
      .then(response => {
        /** @type {DeviceTokenInfo} */
        const deviceTokenInfo = response.data.data;

        this.deviceToken = deviceTokenInfo.deviceToken;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    save() {
      if(this.isSaving) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      const deviceToken = this.deviceToken;
      if(deviceToken === null) {
        notifier.showError('Device token must be specified', {sender: this});
        return;
      }

      const data = new FormData();
      data.set('device_token', deviceToken);

      this.isSaving = true;

      const url = `/player/${this.playerId}/device_token`;
      HTTP.post(url, data)
      .then(() => {
        this.isSaving = false;
        notifier.showSuccessAfterTransition('Device token changed.');
        this.$router.push({name: 'player_device_token_info'});
      })
      .catch(err => {
        this.isSaving = false;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
.device-token {
  word-break: break-all;
  font-family: monospace;
}
</style>
